<template>
  <div class="inp-count input-txt-group">
    <v-text-field v-model="defModel">
      <template v-slot:prepend>
        <v-btn @click="onClick('plus')">
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:append>
        <v-btn @click="onClick('minus')">
          <v-icon>
            mdi-minus
          </v-icon>
        </v-btn>
      </template>
    </v-text-field>
  </div>
</template>
<script setup lang="ts">
import utils from "@/common/Utils";

const props = defineProps(['btnText'])
const defModel = defineModel<number>({ default: 0 })

const onClick=(type)=>{
  if(type == 'plus')
    defModel.value++
  if(type == 'minus' && defModel.value!=0)
    defModel.value--
}
</script>


<style lang="scss">
.inp-count{
  display:inline-flex;
  &.input-txt-group{
    .v-field__input{
      min-height:4rem;
      padding:0 !important;
    }
    .v-field__input{
      text-align:center;
    }
    .v-input__control{
      width:7rem
    }
    .v-input--density-default{
      display:flex;
      --v-input-control-height:4rem;
    }
    .v-field--variant-filled .v-field__outline::after{
      border-radius:0;
    }
    .v-field--variant-filled .v-field__outline::before{
      border-radius:0;
    }
  }
  .v-input--center-affix .v-input__prepend,
  .v-input--center-affix .v-input__append{
    margin-inline-end:0;
    .v-btn{
      border-radius:.5rem 0 0 .5rem;
    }
  }
  .v-input--horizontal .v-input__append{
    margin-inline-start:0;
    .v-btn{
      border-radius:0 .5rem .5rem 0;
    }
  }
  button.v-btn{
    padding:0;
    width:5rem;
    min-width:5rem;
    height:4rem;
    line-height:4rem;
    text-align:center;
    color:var(--color-white);
    background: var(--color-main);
    font-size:1.6rem;
    font-weight:500;
    box-shadow:none;
    letter-spacing:0;
  }
}
@media (max-width: 853px){
  .inp-count{
    &.input-txt-group .v-input__control{
      width:4rem;
    }
    button.v-btn{
      width:4rem;
      min-width:4rem;
    }
  }
}
</style>
